import { Component, OnInit } from '@angular/core';
import { APIService } from './common/api.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private apiService: APIService) {}

  ngOnInit() {
    this.apiService.fatchTeamsId();
    this.apiService.setTheme();
  }
}

export class GlobalConstants {
  public static Tid: string = "";//2ec76bf0-6ce3-48b9-8063-cf657f4ad04b //For PenTest: 16841219-01D1-4AC4-AEB2-A90E5DB56ED9
  public static Name: string = "";
  public static Jwi: string = "";
  public static siteFolderId: number = 0;
  public static siteName: string = "";
  public static theme: string = "light";
  public static isUnit: boolean=true;
  public static IsTeamsIni: boolean = false;
}
